import { render, staticRenderFns } from "./view_old.vue?vue&type=template&id=81e18820&scoped=true"
import script from "./view_old.vue?vue&type=script&lang=js"
export * from "./view_old.vue?vue&type=script&lang=js"
import style0 from "./view_old.vue?vue&type=style&index=0&id=81e18820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e18820",
  null
  
)

export default component.exports